export const GET_COLOR_REQUEST = 'GET_COLOR_REQUEST';
export const GET_COLOR_DATA = 'GET_COLOR_DATA';
export const GET_COLOR_ERROR = 'GET_COLOR_ERROR';

export const CREATE_COLOR_REQUEST = 'CREATE_COLOR_REQUEST';
export const CREATE_COLOR_DATA = 'CREATE_COLOR_DATA';
export const CREATE_COLOR_ERROR = 'CREATE_COLOR_ERROR';

export const UPDATE_COLOR_REQUEST = 'UPDATE_COLOR_REQUEST';
export const UPDATE_COLOR_DATA = 'UPDATE_COLOR_DATA';
export const UPDATE_COLOR_ERROR = 'UPDATE_COLOR_ERROR';

export const DELETE_COLOR_REQUEST = 'DELETE_COLOR_REQUEST';
export const DELETE_COLOR_DATA = 'DELETE_COLOR_DATA';
export const DELETE_COLOR_ERROR = 'DELETE_COLOR_ERROR';
